/** Defines when a policy shall be executed. */
export var ApplyPolicy;
(function (ApplyPolicy) {
    /** After the resolver was executed. */
    ApplyPolicy["AfterResolver"] = "AFTER_RESOLVER";
    /** Before the resolver was executed. */
    ApplyPolicy["BeforeResolver"] = "BEFORE_RESOLVER";
    /** The policy is applied in the validation step before the execution. */
    ApplyPolicy["Validation"] = "VALIDATION";
})(ApplyPolicy || (ApplyPolicy = {}));
export var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["Email"] = "EMAIL";
})(DeliveryMethod || (DeliveryMethod = {}));
export var DigestType;
(function (DigestType) {
    DigestType["Daily"] = "DAILY";
    DigestType["OnDemand"] = "ON_DEMAND";
    DigestType["Weekly"] = "WEEKLY";
})(DigestType || (DigestType = {}));
export var RecognitionPreference;
(function (RecognitionPreference) {
    RecognitionPreference["AnonymousForPublicRecognition"] = "ANONYMOUS_FOR_PUBLIC_RECOGNITION";
    RecognitionPreference["OptoutFromPublicRecognitionPrograms"] = "OPTOUT_FROM_PUBLIC_RECOGNITION_PROGRAMS";
    RecognitionPreference["PreferedNameForPublicRecognition"] = "PREFERED_NAME_FOR_PUBLIC_RECOGNITION";
})(RecognitionPreference || (RecognitionPreference = {}));
export var SortEnumType;
(function (SortEnumType) {
    SortEnumType["Asc"] = "ASC";
    SortEnumType["Desc"] = "DESC";
})(SortEnumType || (SortEnumType = {}));
/** Defines what color scheme to use for the application. This is a global user preference setting. */
export var Theme;
(function (Theme) {
    /** Automatically determine the theme based on the enduser Operating System settings. */
    Theme["Auto"] = "AUTO";
    /** Set the theme to use the Dark Color scheme. */
    Theme["Dark"] = "DARK";
    /** Set the theme to use the Light Color scheme. */
    Theme["Light"] = "LIGHT";
})(Theme || (Theme = {}));
export class TypedDocumentString extends String {
    constructor(value, __meta__) {
        super(value);
        this.value = value;
        this.__meta__ = __meta__;
    }
    toString() {
        return this.value;
    }
}
export const UpdateThemeDocument = new TypedDocumentString(`
    mutation UpdateTheme($theme: Theme!) {
  authz_updateMySettings(theme: $theme) {
    theme
  }
}
    `);
export const Authz_MySettingsDocument = new TypedDocumentString(`
    query authz_mySettings {
  authz_mySettings {
    theme
  }
}
    `);
export const SetIsLatestUserInterfaceEnabledDocument = new TypedDocumentString(`
    mutation setIsLatestUserInterfaceEnabled($enable: Boolean!, $userInterface: String) {
  setIsLatestUserInterfaceEnabled(enable: $enable, userInterface: $userInterface) {
    useLatestUserInterface
  }
}
    `);
export const IsLatestUserInterfaceEnabledDocument = new TypedDocumentString(`
    query isLatestUserInterfaceEnabled($userInterface: String) {
  isLatestUserInterfaceEnabled(userInterface: $userInterface)
}
    `);
